import { createContext } from "@wss/react";
import { Store } from "@wss/store";

export interface ProductDetailsStore {
  isGoogleView: boolean;
}

export const [ProductDetailsContext, useProductDetailsContext] = createContext<
  Store<ProductDetailsStore>
>();

// for test purposes
export const defaultProductDetailsStore: ProductDetailsStore = {
  isGoogleView: false,
};
